import React from "react";

export interface WithAemImageSelectorProps {
  datasource: string | undefined;
  isPageEditing: boolean | undefined;
}

export const withAemImageSelector = <T extends WithAemImageSelectorProps>(
  WrappedComponent: React.ComponentType<T>
) => {
  return (props: Omit<T, "datasource">) => {
    const { isPageEditing } = props as T;

    if (isPageEditing) {
      return (
        <div>
          <div className="p-3 mb-2 bg-danger text-white">
            <h2>AEM Image Selector</h2>
            <p>
              Functionality to pick an image from AEM and persist it back to the
              component datasource. In this case the datasource item id is{" "}
              {(props as T).datasource}
            </p>
            <button type="button" className="btn btn-primary">
              Select Image
            </button>
          </div>
          <WrappedComponent {...(props as T)} />
        </div>
      );
    } else {
      return <WrappedComponent {...(props as T)} />;
    }
  };
};
